import { TRootState } from 'Redux/Reducers';
import { arrayContains } from 'utils';
import Actions from 'Redux/Actions';

export const isInsuranceCooperationLoading = (state: TRootState): boolean =>
  arrayContains([...state.insuranceCooperation.openRequests, ...state.user.openRequests], [
    Actions.registerWithInsuranceNumberRequest.type,
    Actions.registerUserWithOnetimePasswordRequest.type,
  ]);
